import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SodState {
  sodId: string | null
}

const initialState: SodState = {
  sodId: null,
}

const sodSlice = createSlice({
  name: 'sod',
  initialState,
  reducers: {
    setSodId(state, action: PayloadAction<string>) {
      state.sodId = action.payload
    },
    clearSodId(state) {
      state.sodId = null
    },
  },
})

export const { setSodId, clearSodId } = sodSlice.actions

export default sodSlice.reducer
